import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { PageHead } from "@/components/desk/DeskLayout";
import { Field } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const FIELDS = [["site_name", "Site name"], ["tagline", "Tagline (English)"], ["tagline_ta", "Tagline (Tamil)"], ["contact_email", "Contact email"], ["contact_phone", "Contact phone"],
  ["default_trend_hours", "Default Hot/Breaking timer (hours)"]];
const AREAS = [["contact_address", "Contact address"], ["disclaimer", "Disclaimer page"], ["copyright", "Copyright page"]];

export default function SettingsPage() {
  const { setSettings } = useSite();
  const [form, setForm] = useState(null);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setForm(r.data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const body = { ...form, default_trend_hours: Number(form.default_trend_hours) || 0 };
      await api.put("/admin/settings", body);
      setSettings(body);
      toast.success("Settings saved");
    } catch (err) {
      toast.error(fmtErr(err));
    }
  };

  if (!form) return null;
  return (
    <div data-testid="settings-page">
      <PageHead title="Site settings" sub="Branding, contact details and legal pages." />
      <form onSubmit={save} className="bg-white border border-zinc-200 p-5 max-w-3xl space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          {FIELDS.map(([k, l]) => (
            <Field key={k} label={l}>
              <Input data-testid={`settings-${k}`} value={form[k] ?? ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="rounded-sm" />
            </Field>
          ))}
        </div>
        {AREAS.map(([k, l]) => (
          <Field key={k} label={l}>
            <Textarea data-testid={`settings-${k}`} value={form[k] ?? ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="rounded-sm min-h-[110px]" />
          </Field>
        ))}
        <Button data-testid="settings-save-btn" className="rounded-sm">Save settings</Button>
      </form>
    </div>
  );
}
